import type { FlatSurface, PlacementPosition, SurfaceOutline } from '@repo/api-contracts';

/**
 * 윤곽 점(사진 %)을 표면 실측 mm 로 바꾼다. 계약 isPlacementInsideOutline 의 toPercent 와 정확한 역함수다.
 */
export const outlineToSurfaceMm = (
  surface: FlatSurface & { outline: SurfaceOutline },
): PlacementPosition[] => {
  const [topLeft, , bottomRight] = surface.points;
  const { widthMm, heightMm } = surface.realSize;
  return surface.outline.points.map((point) => ({
    xMm: ((point.x - topLeft.x) / (bottomRight.x - topLeft.x)) * widthMm,
    yMm: ((point.y - topLeft.y) / (bottomRight.y - topLeft.y)) * heightMm,
  }));
};

/** '전체 영역 (앞면)' — 이미 있으면 ' 2', ' 3'… 을 붙인다. */
export const fullAreaName = (faceLabel: string, existing: readonly string[]): string => {
  const base = `전체 영역 (${faceLabel})`;
  if (!existing.includes(base)) return base;
  let count = 2;
  while (existing.includes(`${base} ${count}`)) count += 1;
  return `${base} ${count}`;
};
